import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Star } from "lucide-react";

const Stars = ({ v }) => (
  <span className="inline-flex">
    {[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`h-3.5 w-3.5 ${n <= Math.round(v) ? "fill-amber-400 text-amber-400" : "text-white/20"}`} />)}
  </span>
);

export function CallQualityPanel() {
  const { data } = useQuery({ queryKey: ["admin-call-quality"], queryFn: async () => (await api.get("/admin/call-quality")).data, refetchInterval: 15000 });
  if (!data) return <div className="h-40 rounded-2xl bg-white/5 animate-pulse" />;
  return (
    <div data-testid="call-quality-panel" className="space-y-6">
      <div className="glass rounded-2xl p-5 flex items-center gap-4">
        <span data-testid="cq-overall-avg" className="font-display font-black text-4xl gold-text">{data.overall.avg ?? "—"}</span>
        <div><Stars v={data.overall.avg || 0} /><p className="text-xs text-slate-400 mt-1">{data.overall.count} ratings overall</p></div>
      </div>
      <div className="glass rounded-2xl p-5">
        <h3 className="font-display font-bold mb-3">By country pair</h3>
        {data.by_pair.length === 0 ? <p className="text-sm text-slate-400">No ratings yet.</p> : (
          <div className="divide-y divide-white/5">
            {data.by_pair.map((p) => (
              <div key={p.pair} data-testid="cq-pair-row" className="py-2.5 flex items-center gap-3 text-sm">
                <span className="flex-1 font-semibold">{p.pair}</span>
                <Stars v={p.avg} /><span className="w-10 text-right font-mono-doek">{p.avg}</span>
                <span className="w-24 text-right text-xs text-slate-400">{p.count} calls · {p.reconnects} drops</span>
                <span className="w-20 text-right text-xs text-slate-400">{p.audio_only} voice-only</span>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="glass rounded-2xl p-5">
        <h3 className="font-display font-bold mb-3">Latest feedback</h3>
        <div className="space-y-3">
          {data.recent.map((r) => (
            <div key={r.id} data-testid="cq-recent-row" className="text-sm">
              <div className="flex items-center gap-2"><Stars v={r.stars} /><span className="text-slate-300">{r.name}</span><span className="text-xs text-slate-500">{r.pair} · net {r.net_state || "?"}</span></div>
              {r.comment && <p className="text-slate-400 mt-0.5">"{r.comment}"</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
